module.exports = __webpack_public_path__ + "img/sw-face-xs.5ba47a51.webp";